<div class="filter-container">
  <mat-form-field appearance="standard">
    <mat-icon matPrefix>search</mat-icon>
    <mat-label>{{ label }}</mat-label>
    <input 
      matInput 
      (keyup)="applyFilter($event)"
      #filterInput>
  </mat-form-field>
  
  <button 
    mat-icon-button 
    *ngIf="hasFilter" 
    (click)="clearFilter()" 
    class="clear-filter"
    aria-label="Clear filter">
    <mat-icon>clear</mat-icon>
  </button>
</div>
